import { LayoutGrid, Rows3 } from "lucide-react";

export type ViewMode = "grid" | "compact";

type Props = {
  value: ViewMode;
  onChange: (v: ViewMode) => void;
};

export function ViewToggle({ value, onChange }: Props) {
  return (
    <div className="view-toggle" role="group" aria-label="View mode">
      <button
        type="button"
        className={`view-toggle-btn${value === "grid" ? " is-active" : ""}`}
        onClick={() => onChange("grid")}
        aria-pressed={value === "grid"}
        title="Grid view"
      >
        <LayoutGrid size={14} />
      </button>
      <button
        type="button"
        className={`view-toggle-btn${value === "compact" ? " is-active" : ""}`}
        onClick={() => onChange("compact")}
        aria-pressed={value === "compact"}
        title="Compact view"
      >
        <Rows3 size={14} />
      </button>
    </div>
  );
}
